import { render } from "./AddMenuPage.vue?vue&type=template&id=9b595d40&ts=true"
import script from "./AddMenuPage.vue?vue&type=script&lang=ts"
export * from "./AddMenuPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__